import NoteType from "@/models/Notes/NoteType";

export default (value: NoteType) => {
    switch (value) {
        case NoteType.General:
            return "General";
        case NoteType.Call:
            return "Call";
        case NoteType.Meeting:
            return "Meeting";
        default:
            return "Unknown";
    }
} 